/**
 * Kurumsal bütçe/politika dışı uçuşlar için "Onaya Gönder" akışının uçağa özel ince
 * adaptörü. Çekirdek mantık ortak modülde: `src/components/booking/corporateApproval.ts`
 * (otel/otobüs/transfer/araç kiralama da onu kullanır). Buradaki sarmalayıcılar yalnızca
 * `AirFlowState`'ten `ApprovalGateInput` kurup ortak fonksiyonlara delege eder.
 */
import {
  approvalEmployeeId as approvalEmployeeIdCore,
  corporateMaxBudget as corporateMaxBudgetCore,
  isOverBudget as isOverBudgetCore,
  needsCorporateApproval as needsCorporateApprovalCore,
  type ApprovalGateInput,
} from '../../components/booking/corporateApproval';
import type { AirFlowState } from './flowConfig';

export {
  toIsoDateOnly,
  employeeToPassenger,
  employeeToContact,
} from '../../components/booking/corporateApproval';

/** `AirFlowState` → ortak onay kapısı girdisi. `Air/Allocate` yanıtı sepette
 *  `EmployeeID` / `IsOutBudget` / `PolicySendApproval` / `MaxBudget` taşır; seçili ücret
 *  (tek yön / dönüş / çok noktalı ilk bacak) de bütçe bayrağı taşıyabilir. */
function toGateInput(state: AirFlowState): ApprovalGateInput {
  return {
    cart: state.shoppingCart,
    extraOverBudget:
      state.selectedFare?.isOutBudget === true ||
      state.selectedReturnFare?.isOutBudget === true ||
      state.selectedOption?.isOutBudget === true,
    extraMaxBudget: state.selectedFare?.maxBudget ?? state.selectedOption?.maxBudget ?? null,
  };
}

/** Seçilen uçuş bütçe/politika dışı mı. */
export function isOverBudget(state: AirFlowState): boolean {
  return isOverBudgetCore(toGateInput(state));
}

/** Yolcu adımının "Onaya Gönder" (salt-okunur personel bilgisi) modunda olup olmadığı:
 *  allocate sonrası sepette **`EmployeeID` var** ve uçuş **bütçe/politika dışı**. */
export function needsCorporateApproval(state: AirFlowState): boolean {
  return needsCorporateApprovalCore(toGateInput(state));
}

/** Yolcu bilgisini hangi personelden çekeceğiz: sepetteki `EmployeeID`, yoksa oturum
 *  sahibinin personel kimliği. */
export function approvalEmployeeId(
  state: AirFlowState,
  sessionEmployeeId: number | null | undefined
): number | undefined {
  return approvalEmployeeIdCore(toGateInput(state), sessionEmployeeId);
}

/** İzin verilen kurumsal uçuş bütçesi (bilgi metni için). */
export function corporateMaxBudget(state: AirFlowState): number | null {
  return corporateMaxBudgetCore(toGateInput(state));
}
